export default __webpack_public_path__ + "0f55e89b62a8b243ff28a089e232cf03.png";